<script setup lang="ts"></script>
<template>
  <div class="fixed bottom-0 left-0 top-0 z-50 w-full">
    <div class="loader-holder">
      <div class="loader"></div>
    </div>
  </div>
</template>
